import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";

const Page = lazy(() =>
  import("@/components/admin/pages/user").then((module) => ({
    default: module.UserPage,
  })),
);

export const Route = createFileRoute("/admin/users/$userId")({
  component: Page,
});
